import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { DEFAULTS, useContent } from "@/lib/content";
import { COLLECTIONS, COL_LABELS } from "./constants";

export default function CollectionOrder() {
  const { content, setContent } = useContent();
  const parse = (s) => {
    const a = (s || "").split(",").map((x) => x.trim()).filter((c) => COLLECTIONS.includes(c));
    return [...a, ...COLLECTIONS.filter((c) => !a.includes(c))];
  };
  const [order, setOrder] = useState(parse(content.collection_order));
  const [drag, setDrag] = useState(null);

  useEffect(() => { setOrder(parse(content.collection_order)); }, [content.collection_order]);

  const save = async (next) => {
    setOrder(next);
    try {
      const { data } = await api.put("/admin/content", { updates: { collection_order: next.join(",") } });
      setContent && setContent({ ...DEFAULTS, ...data });
      toast.success("Homepage order saved");
    } catch {
      toast.error("Could not save order");
    }
  };
  const move = (from, to) => {
    if (to < 0 || to >= order.length || from === to) return;
    const a = [...order];
    const [m] = a.splice(from, 1);
    a.splice(to, 0, m);
    save(a);
  };

  return (
    <div className="border-2 border-[#DFFF00] p-5 mb-8" data-testid="collection-order">
      <p className="overline text-[#DFFF00] mb-1">Homepage Collection Order</p>
      <p className="font-mono-ui text-[0.65rem] opacity-60 mb-3">Drag (or ▲▼) to set how the four collections stack top-to-bottom on the site</p>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
        {order.map((c, i) => (
          <div
            key={c}
            draggable
            onDragStart={() => setDrag(i)}
            onDragOver={(e) => e.preventDefault()}
            onDrop={() => { move(drag, i); setDrag(null); }}
            onDragEnd={() => setDrag(null)}
            data-testid={`collection-order-item-${c}`}
            className={`flex items-center gap-3 border-2 p-3 cursor-grab active:cursor-grabbing ${drag === i ? "opacity-40 border-[#DFFF00]" : "border-[#F2EFEB]/40"}`}
          >
            <span className="opacity-50 select-none">⠿</span>
            <span className="font-mono-ui text-[#DFFF00] w-6 text-center">{i + 1}</span>
            <span className="flex-1 uppercase text-sm">{COL_LABELS[c]}</span>
            <button onClick={() => move(i, i - 1)} disabled={i === 0} data-testid={`col-up-${c}`} className="px-2 hover:text-[#DFFF00] disabled:opacity-20">▲</button>
            <button onClick={() => move(i, i + 1)} disabled={i === order.length - 1} data-testid={`col-down-${c}`} className="px-2 hover:text-[#DFFF00] disabled:opacity-20">▼</button>
          </div>
        ))}
      </div>
    </div>
  );
}
